import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiChevronRight, FiMapPin, FiPhone } from "react-icons/fi";
import {Link} from "react-router-dom";

const HeaderTopBar = () => {
    return (
        <div className="header-top-bar">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="header-left">
                            <p>Best Quality and Most Affordable</p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="header-right">
                            <div className="address-content">
                                <p><FiMapPin /><span>Shimla, India</span></p>
                                <p><FiPhone /><span><a href="#">+91 70188-32031</a></span></p>
                            </div>
                            <div className="social-icon-wrapper">
                                <ul className="social-icon social-default icon-naked">
                                    <li><a href="https://facebook.com/adeveloper.buddy"><FiFacebook /></a></li>
                                    <li><a href="https://twitter.com/developer.buddy"><FiTwitter /></a></li>
                                    <li><a href="https://instagram.com/developer.buddy"><FiInstagram /></a></li>
                                    <li><a href="https://linkdin.com/developer.buddy"><FiLinkedin /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopBar;
